module.exports = __webpack_public_path__ + "static/media/lvsa.d3b159a3.png";